export enum UserRole {
  Administrator = 'Administrator',
  SuperAdministrator = 'SuperAdministrator',
  Client = 'Client',
}

export enum StorageKeys {
  session_token = 'session-token',
}

export type serverError = { status: number; data: null; message: string };

export type ErrorMessage = { [key: string]: { [errorKey: string]: string } };

export type StringOrNull = string | null;
export type NumberOrNull = number | null;
export type DateOrNull = Date | null;
export type BoolOrNull = boolean | null;

export enum InputTypes {
  short_text = 'short_text',
  long_text = 'long_text',
  radio = 'radio',
  checkbox = 'checkbox',
  select = 'select',
  range = 'range',
  phone = 'phone',
  email = 'email',
  rut = 'rut',
  date = 'date',
  hour = 'hour',
  rate = 'rate'
}

export enum RewardCategories {
  grandes_tiendas = 'Grandes Tiendas',
  comida_rapida = 'Comida Rapida',
  gastronomia = 'Gastronomia'
}

export interface IApiResponse<T> {
  data: null | T;
  status: number;
  message: string;
}
